import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-monitor",
  "use": "icon-monitor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-monitor\"><path d=\"M810.666667 128H213.333333a128 128 0 0 0-128 128v213.333333h853.333334V256a128 128 0 0 0-128-128zM85.333333 597.333333a128 128 0 0 0 128 128h256v85.333334H298.666667a42.666667 42.666667 0 0 0 0 85.333333h426.666666a42.666667 42.666667 0 0 0 0-85.333333h-170.666666v-85.333334h256a128 128 0 0 0 128-128v-42.666666H85.333333z\" p-id=\"12032\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol